module.exports = __webpack_public_path__ + "static/media/ill_error_dkids.b8eb1603.png";